// extracted by mini-css-extract-plugin
module.exports = {"root":"reviewUpdate_root__1dZix","form":"reviewUpdate_form__3Xdyh","select":"reviewUpdate_select__1M3Dz","contentInput":"reviewUpdate_contentInput__HeKcA"};